import React, { FC, useLayoutEffect } from "react";
import { useFormikContext } from "formik";
import { useAuth } from "context/auth-context";

type QueryOptions = {
  [name: string]: string | number | undefined;
};

function queryBuilder(options: QueryOptions) {
  let queryString = "";
  const keys = Object.keys(options);

  let hasOptions = false;

  for (const key of keys) {
    if (options[key] !== null && options[key] !== undefined) {
      if (!hasOptions) {
        // add ? for query and change the switch
        // so we don't add it anymore
        hasOptions = true;
        queryString += "?";
      }
      queryString += `${key}=${options[key]}&`;
    }
  }

  queryString = queryString.substring(0, queryString.length - 1);

  return queryString;
}

function useSafeDispatch(dispatch: Function) {
  const mounted = React.useRef(false);
  React.useLayoutEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return React.useCallback(
    (...args) => (mounted.current ? dispatch(...args) : void 0),
    [dispatch]
  );
}

const InitializeBranchId: FC = () => {
  const { setFieldValue } = useFormikContext();
  const {
    user: { branchId },
  } = useAuth();
  useLayoutEffect(() => {
    setFieldValue("branchId", branchId);
  }, [branchId, setFieldValue]);
  return null;
};

export { queryBuilder, useSafeDispatch, InitializeBranchId };
